import { IOnePlusManyInstanceConfig } from 'common/contracts';

import { BuyOneGetManyDesignsMetadata } from 'components/TemplatesStudio/DesignsMetadata/types';

export const designMatchesRewardsLayout = (
  design: Pick<BuyOneGetManyDesignsMetadata, 'rewardsLayouts'>,
  rewardsLayout: IOnePlusManyInstanceConfig['rewardsLayout']
): boolean => design.rewardsLayouts.includes(rewardsLayout);
